/**
 * Relative time formatter — used by the Action History "When" column.
 * Returns "just now" / "5m ago" / "2h ago" / "3d ago" / "2w ago" /
 * "3mo ago" / "1y ago" depending on delta. Previously fell back to an
 * absolute date for anything >7d which users read as "no time column"
 * (V5.2, 2026-04-24) — the relative framing is preserved all the way
 * up so stale audit entries still read like relative time.
 */
export function relativeTime(iso: string, now: Date = new Date()): string {
  const t = Date.parse(iso)
  if (Number.isNaN(t)) return iso
  const deltaSec = Math.floor((now.getTime() - t) / 1000)
  if (deltaSec < 0) return 'in the future'
  if (deltaSec < 30) return 'just now'
  if (deltaSec < 60) return `${deltaSec}s ago`
  if (deltaSec < 3600) return `${Math.floor(deltaSec / 60)}m ago`
  if (deltaSec < 86400) return `${Math.floor(deltaSec / 3600)}h ago`
  if (deltaSec < 7 * 86400) return `${Math.floor(deltaSec / 86400)}d ago`
  if (deltaSec < 30 * 86400) return `${Math.floor(deltaSec / (7 * 86400))}w ago`
  if (deltaSec < 365 * 86400) return `${Math.floor(deltaSec / (30 * 86400))}mo ago`
  return `${Math.floor(deltaSec / (365 * 86400))}y ago`
}
